const convertKeyAsLabel = key => {
  const formattedKey = (key || '').replace(/([A-Z])/g, ' $1').trim();
  return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
};

export default convertKeyAsLabel;
